/** Shared UI bridge between the ERP sidebar/header and the mounted workspace. Reset on workspace unmount. */
import { reactive } from 'vue';

export const trackingNavigation = reactive({
  view: 'dashboard',
  caseRef: '',
  total: null,
  busy: false,
  permissions: {},
  navigate: null,
});
export const trackingViews = ['dashboard', 'cases', 'new', 'links', 'reports', 'sources'];
